import { render, staticRenderFns } from "./platdealdetail.vue?vue&type=template&id=5b7fad20&"
import script from "./platdealdetail.vue?vue&type=script&lang=js&"
export * from "./platdealdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports